import React, { useState } from 'react';
import { Input } from 'reactstrap';
import SelectCompany from './selectCompanyView';
import type { Company } from '../../../../../models/companies/company';

interface Field {
  id: number;
  companyId: number | null;
  wishedSellPrice: string | null;
}

interface SellWish {
  companyId: number;
  wishedSellPrice: string;
}

interface Props {
  companies: Company[];
  wishedSellPrices: Record<string, string>;
  defaultData: SellWish[];
}

export default function SelectCompaniesToSellView(props: Props) {
  const { companies, wishedSellPrices, defaultData } = props;

  const convertToFields = (sellWishes: SellWish[]): Field[] => {
    return sellWishes.map((sellWish, i) => ({
      id: i,
      companyId: sellWish.companyId,
      wishedSellPrice: sellWish.wishedSellPrice,
    }));
  };

  const [fields, setFields] = useState<Field[]>(convertToFields(defaultData));

  const onAddField = () => {
    let nextID = 0;
    if (fields.length > 0) {
      nextID = fields[fields.length - 1].id + 1;
    }

    setFields([
      ...fields,
      {
        id: nextID,
        companyId: null,
        wishedSellPrice: null,
      },
    ]);
  };

  const onRemoveField = (id: number) => {
    setFields(fields.filter(c => c.id !== id));
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <div className="sell-form-wrapper">
      {fields.map(field => (
        <fieldset
          key={field.id}
          id={`company_to_sell_${field.id}`}
          className="fieldset-row"
        >
          <div className="form-unit">
            <SelectCompany
              companies={companies}
              inputName={`market_demand_questionnaire[fundinno_stock_sell_wishes_attributes][${field.id}][company_id]`}
              className="company-select"
              defaultCompanyId={field.companyId}
              placeholder="保有されている銘柄"
            />
            <span className="sell-form-caption">を購入時と比べて</span>
            <Input
              name={`market_demand_questionnaire[fundinno_stock_sell_wishes_attributes][${field.id}][wished_sell_price_level]`}
              className="wished-sell-price"
              type="select"
              placeholder="select"
              defaultValue={field.wishedSellPrice || ''}
              onKeyDown={onKeyDown}
            >
              <option value="" />
              {Object.keys(wishedSellPrices).map((e, i) => (
                <option key={i} value={e}>
                  {wishedSellPrices[e]}
                </option>
              ))}
            </Input>
            <span className="sell-form-caption">売りたい。</span>
          </div>
          <button
            type="button"
            onClick={() => onRemoveField(field.id)}
            className="icon-button"
          >
            <i className="fas fa-minus-circle" />
          </button>
        </fieldset>
      ))}
      <button
        type="button"
        onClick={() => onAddField()}
        className="icon-button"
      >
        <i className="fas fa-plus-circle" />
      </button>
    </div>
  );
}
